$(function () {
    $('.inschrijven-optie__optie').each(function (i, el) {
        $(this).find('.inschrijven-optie__optie-link').show().on('click', function () {
            $(el).submit()
        });
        $(this).find('.inschrijven-optie__optie-button').remove();
    })
});